import React from "react";
import { MessageBanner } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
/**
 * Tells the user that a list opened without the filters that depend on who
 * they are (their own publisher, agency-only filters) because the logged-in
 * user could not be loaded.
 */
export var CurrentUserLoadErrorBanner = function (_a) {
    var show = _a.show;
    return show ? (React.createElement(MessageBanner, { type: "error" },
        React.createElement(FormattedMessage, { id: "ui-br-agency.currentUser.loadError" }))) : null;
};
